import React from "react";
import { Reveal } from "./Reveal";

export default function SectionHead({ tag, title, desc, center = false }) {
  return (
    <div className={`max-w-4xl ${center ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <span className={`rq-tag ${center ? "justify-center" : ""}`}>
          <span className="h-px w-6 bg-[color:var(--rq-green)] inline-block" />
          {tag}
        </span>
      </Reveal>
      <Reveal delay={80}>
        <h2 className="font-display mt-5 text-4xl md:text-6xl lg:text-[64px] font-bold leading-[1.06] tracking-tight text-white">
          {title}
        </h2>
      </Reveal>
      {desc && (
        <Reveal delay={160}>
          <p className="mt-6 text-base md:text-xl leading-relaxed text-[color:var(--rq-muted)]">
            {desc}
          </p>
        </Reveal>
      )}
    </div>
  );
}
